import React from "react";
import PropTypes from "prop-types";
import {
  Modal,
  ModalBody,
  Label,
  Row,
  Col,
  Progress,
  ModalFooter,
} from "reactstrap";

import { AvForm, AvField } from "availity-reactstrap-validation";
import ReactSelect from "react-select";
import CustomSelect from "../../../components/Common/CustomSelect";

const AddUserModal = props => {
  const { isOpen, toggle, addUser } = props;
  const [strong, setStrong] = React.useState({
    value: 0,
    type: "danger",
    text: " empty",
  });
  const [isFormSubmit, setIsFormSubmit] = React.useState(false);
  const [selectedPositions, setSelectedPositions] = React.useState();

  const onSubmitForm = (e, errors, params) => {
    setIsFormSubmit(true);
    if (errors?.length === 0) {
      let data = {
        ...params,
      };
      data["positions"] = [];
      params.positions.map(i => {
        data["positions"].push(i.value);
      });
      addUser(data);
      return toggle();
    }
  };

  const passStrong = value => {
    if (value.length >= 16) {
      setStrong({ value: 100, type: "success", text: " is very strong" });
    } else if (value.length >= 10) {
      setStrong({ value: 75, type: "success", text: " is strong" });
    } else if (value.length >= 8) {
      setStrong({ value: 50, type: "warning", text: " is good" });
    } else if (value.length >= 6) {
      setStrong({ value: 25, type: "danger", text: " too simple" });
    } else if (value.length < 6) {
      setStrong({ value: 5, type: "danger", text: " is so short" });
    }
  };

  return (
    <Modal isOpen={isOpen} autoFocus={true} centered={true} toggle={toggle}>
      <AvForm className="needs-validation" onSubmit={onSubmitForm}>
        <div className="modal-header">
          <h4 className="modal-title mt-0" id="myModalLabel">
            Add user
          </h4>
          <button
            type="button"
            onClick={toggle}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <ModalBody>
          <Row form>
            <Col xl={12}>
              <Row>
                <Col className="col-6">
                  <div className="mb-3">
                    <AvField
                      name="username"
                      label="Username"
                      placeholder="Username..."
                      type="text"
                      errorMessage="Username is empty"
                      validate={{
                        required: { value: true },
                        minLength: { value: 3, errorMessage: "Min 1 word" },
                        maxLength: {
                          value: 255,
                          errorMessage: "Max 255 words",
                        },
                      }}
                    />
                  </div>
                </Col>
                <Col className="col-12">
                  <div className="mb-3">
                    <Label htmlFor="validationCustom02">Positions</Label>
                    <CustomSelect
                      name="positions"
                      options={props.positions}
                      placeholder="Select position..."
                      defaultValue={selectedPositions}
                      onChange={setSelectedPositions}
                      classNamePrefix="select2-selection"
                      errorMessage="Position field is required!"
                      isFormSubmit={isFormSubmit}
                      isMulti
                      required
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col className="col-6">
                  <div className="mb-3">
                    <AvField
                      name="first_name"
                      label="First name"
                      type="text"
                      placeholder="First name..."
                      errorMessage="First name is empty"
                      validate={{
                        required: { value: true },
                        minLength: { value: 3, errorMessage: "Min 1 word" },
                        maxLength: {
                          value: 255,
                          errorMessage: "Max 255 words",
                        },
                      }}
                    />
                  </div>
                </Col>
                <Col className="col-6">
                  <div className="mb-3">
                    <AvField
                      name="last_name"
                      label="Last name"
                      type="text"
                      placeholder="Last name..."
                      errorMessage="Last name is empty"
                      validate={{
                        required: { value: true },
                        minLength: { value: 3, errorMessage: "Min 1 word" },
                        maxLength: {
                          value: 255,
                          errorMessage: "Max 255 words",
                        },
                      }}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col className="col-6">
                  <div className="mb-3">
                    <AvField
                      name="phone"
                      label="Phone"
                      placeholder="Phone number..."
                      type="text"
                      errorMessage="Phone is empty"
                      validate={{
                        required: { value: true },
                        minLength: { value: 1, errorMessage: "Min 1 word" },
                        maxLength: {
                          value: 15,
                          errorMessage: "Max 255 words",
                        },
                      }}
                    />
                  </div>
                </Col>
                <Col className="col-6">
                  <div className="mb-3">
                    <AvField
                      name="email"
                      label="Email"
                      placeholder="example@gmail.com"
                      type="text"
                      errorMessage="Enter correct email address"
                      validate={{
                        required: { value: true },
                        minLength: { value: 3, errorMessage: "Min 1 word" },
                        maxLength: {
                          value: 255,
                          errorMessage: "Max 255 words",
                        },
                        email: { value: true },
                      }}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col className="col-6">
                  <div className="mb-3">
                    <AvField
                      name="password"
                      label="Password"
                      placeholder="Password..."
                      type="password"
                      validate={{
                        required: { value: true },
                        minLength: { value: 6, errorMessage: "Min 6 words" },
                        maxLength: {
                          value: 255,
                          errorMessage: "Max 255 words",
                        },
                      }}
                      onChange={e => passStrong(e.target.value)}
                    />
                  </div>
                </Col>
                <Col className="col-6">
                  <div className="mb-3">
                    <AvField
                      name="conf_pass"
                      label="Confirm password"
                      type="password"
                      placeholder="Confirm password..."
                      errorMessage={"Password mismatch"}
                      validate={{
                        match: { value: "password" },
                        required: { value: true },
                        maxLength: {
                          value: 255,
                          errorMessage: "Max 255 words",
                        },
                      }}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <div className="mb-1">
                  <Progress
                    value={strong.value}
                    color={strong.type}
                    className="progress-lg"
                  ></Progress>
                </div>
              </Row>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter className="pe-0">
          <Row>
            <Col>
              <div className="text-end">
                <button
                  onClick={e => {
                    e.preventDefault();
                    toggle();
                  }}
                  className="btn btn-primary save-user"
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="btn btn-success save-user ms-2"
                >
                  Save changes
                </button>
              </div>
            </Col>
          </Row>
        </ModalFooter>
      </AvForm>
    </Modal>
  );
};

AddUserModal.propTypes = {
  toggle: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  addUser: PropTypes.func.isRequired,
  positions: PropTypes.array.isRequired,
};

export default AddUserModal;
